module.exports = __webpack_public_path__ + "img/dollar-grey-icon.33326123.svg";